function initSwipers(scope = document) {
  const swipers = scope.querySelectorAll('.swiper');

  swipers.forEach(function (swiperElement) {

    /* prevent double init */
    if (swiperElement.classList.contains('swiper-initialized')) return;

    /* --------------------
       LOGO CAROUSEL
    --------------------- */
    if (swiperElement.classList.contains('myLogoSwiper')) {
      new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: true,

        grabCursor: true,
        simulateTouch: true,
        touchRatio: 1,
        touchStartPreventDefault: false,

        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },

        navigation: {
          nextEl: swiperElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.querySelector('.swiper-button-prev'),
        },

        breakpoints: {
          320: { spaceBetween: 16 },
          768: { spaceBetween: 24 }
        }
      });

      return;
    }

    /* --------------------
       PRODUCT CAROUSEL
    --------------------- */
    if (swiperElement.classList.contains('myProductSwiper')) {
      const slidesCount = swiperElement.querySelectorAll('.swiper-slide').length;

      new Swiper(swiperElement, {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        loopedSlides: slidesCount,
        loopAdditionalSlides: slidesCount,

        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },

        navigation: {
          nextEl: swiperElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.querySelector('.swiper-button-prev'),
        },

        pagination: {
          el: swiperElement.querySelector('.swiper-pagination'),
          clickable: true,
        },

        mousewheel: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
          pageUpDown: true,
        },

        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
      });
    }

  });
}

/* FIRST LOAD */
document.addEventListener('DOMContentLoaded', function () {
  initSwipers();
});

/* 🔥 SHOPIFY SECTION RELOAD (THIS WAS MISSING) */
document.addEventListener('shopify:section:load', function (event) {
  initSwipers(event.target);
});
